<script>
import { mapActions } from 'vuex'
import Store from '@/store/store'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  },
  'password-rules': {
    pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})',
    message: 'Hasło musi zawierać co najmniej jedną: dużą, małą literę i cyfrę oraz minimum 8 znaków.'
  }
}

export default {
  name: 'user-account-create',
  store: Store,
  data () {
    let validatePassword = (rule, value, callback) => {
      if (this.user.passwordAgain !== '') {
        this.$refs.user.validateField('passwordAgain')
      }
      callback()
    }
    let validatePasswordAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('To pole jest wymagane.'))
      } else if (value !== this.user.password) {
        callback(new Error('Wprowadzone hasła są różne.'))
      } else {
        callback()
      }
    }
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        passwordAgain: null
      },
      rules: {
        firstName: [
          commonRules[ 'required-field' ]
        ],
        lastName: [
          commonRules[ 'required-field' ]
        ],
        email: [
          commonRules[ 'required-field' ],
          { type: 'email', message: 'Niepoprawny format adresu email.' }
        ],
        password: [
          commonRules[ 'required-field' ],
          commonRules[ 'password-rules' ],
          { validator: validatePassword }
        ],
        passwordAgain: [
          commonRules[ 'required-field' ],
          { validator: validatePasswordAgain }
        ]
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions([
      'aUserAccountCreate'
    ]),
    submitForm (formName) {
      this.$refs[ formName ].validate((valid) => {
        if (valid) {
          this.aUserAccountCreate(this[ formName ])
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[ formName ].resetFields()
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col
        :span="20"
        :offset="2"
      >
        <h1>Nowe konto</h1>
        <el-form
          ref="user"
          label-width="120px"
          size="small"
          status-icon
          :model="user"
          :rules="rules"
        >
          <el-form-item
            label="imię"
            prop="firstName"
          >
            <el-input
              placeholder="imię"
              v-model="user.firstName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="nazwisko"
            prop="lastName"
          >
            <el-input
              placeholder="nazwisko"
              v-model="user.lastName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="adres email"
            prop="email"
          >
            <el-input
              placeholder="twój@addres.email"
              v-model="user.email"
              type="email"
            ></el-input>
            <el-alert
              type="info"
              style="margin-top: 1rem;"
              show-icon
              :closable=false
            >
              Wprowadź uważnie adres email. Będzie on Twoim loginem do serwisu oraz
              podstawowym kanałem komunikacji podczas realizacji zamówień. Na powyższy
              adres zostanie wysłany link weryfikacyjny. Dokonanie weryfikacji jest
              niezbędne, by móc korzystać z pełnej funkcjonalności serwisu.
            </el-alert>
          </el-form-item>
          <el-form-item
            label="hasło"
            prop="password"
          >
            <el-input
              placeholder="password"
              type="password"
              v-model="user.password"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="powtórz hasło"
            prop="passwordAgain"
          >
            <el-input
              placeholder="wprowadź ponownie hasło"
              type="password"
              v-model="user.passwordAgain"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('user')"
            >Załóż konto</el-button>
            <el-button
              @click="resetForm('user')"
              style="float: right; margin: .5rem 0;"
            >
              Reset
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/user-account-create.vue